import type { APIRequestType} from 'resources/mandark.resource';
import {genericMandarkRequest} from 'resources/mandark.resource';

export const createLtiLineItemQuery = (
  assignmentId: string,
  classroomId: string,
  schoolId: string
): APIRequestType => {
  return genericMandarkRequest(
    'post',
    {
      resourcePath: ['lti', 'line_item_v1']
    },
    {
      assignment_id: assignmentId,
      classroom_id: classroomId,
      school_id: schoolId
    }
  );
};

export const deleteLtiLineItemQuery = (
  assignment_id: string,
  classroom_id: string,
  school_id: string
): APIRequestType => {
  return genericMandarkRequest(
    'delete',
    {
      resourcePath: ['lti', 'line_item_v1']
    },
    {
      assignment_id,
      classroom_id,
      school_id
    }
  );
};
